module.exports = __webpack_public_path__ + "static/media/kitty4.85c58f93.gif";